import { ComponentType, PropsWithChildren, SVGProps } from "react";
import styles from './Avatar.module.css'
import stylesSkeleton from './AvatarSkeleton.module.css'
import Icon, { IconColors, IconTypes } from "../Icon/Icon";

export enum AvatarTypes {
  ROUNDED = 'rounded',
  SQUARE = 'square'
}

export enum AvatarSizes {
  XS = 'extraSmall',
  S = 'small',
  M = 'medium',
  L = 'large',
  MIXED = 'mixed'
}

interface AvatarSkeletonProps {
  className?: string
  shape?: AvatarTypes
  size?: AvatarSizes
}

export function AvatarSkeleton ({ className, shape = AvatarTypes.ROUNDED, size = AvatarSizes.M }: AvatarSkeletonProps) {
  return (
    <div data-testid="Avatar_skeleton" className={`${stylesSkeleton.avatar} ${shape} ${size} ${className ?? ''}`}></div>
  )
}

interface AvatarProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, React.AriaAttributes {
  backgroundUrl: string,
  shape?: AvatarTypes,
  size?: AvatarSizes,
  selected?: boolean,
  focuseable?: boolean,
  icon?: ComponentType<SVGProps<SVGSVGElement>>
}

export default function Avatar ({
  backgroundUrl,
  className,
  type='button',
  shape = AvatarTypes.ROUNDED,
  size = AvatarSizes.M,
  selected = false,
  focuseable = true,
  icon,
  onClick,
  ...props
}: PropsWithChildren<AvatarProps>) {
  return (
    <button 
      type={type}
      className={`
        avatar
        ${styles.avatar} 
        ${shape}
        ${size}
        ${selected ? styles.selected : ''}
        ${className ?? ''}
      `}

      style={{
        backgroundImage: `url(${backgroundUrl})`
      }}

      onClick={onClick}
      tabIndex={!focuseable ? -1 : undefined}
      {...props}
      data-testid="Avatar"
      title="Avatar"
    >
      {icon !== undefined &&
        <Icon
          icon={icon}
          type={IconTypes.SOLID}
          color={IconColors.DARK}
          stroke={true}
          className={styles.icon}
          data-testid="Avatar_icon"
        />
      }
    </button>
  )
}